import React from 'react';
import PropTypes from 'prop-types';

// portalConfiguration - injected at server start-up time, this variable
// contains all portal / environment specific config
// the server side render prints the value of this variable into a global
// var "__PORTAL_CONFIG__" so that the client side can re-hydrate itself

let portalConfiguration = process.env.LOCAL_CONFIG;

export const init = (config = window.__PORTAL_CONFIG__) => {
  portalConfiguration = config;
};

export const getConfig = () => {
  if (!portalConfiguration) {
    init();
  }
  return portalConfiguration;
};

export const PortalConfigContext = React.createContext();

export const PortalConfigProvider = ({ children }) => {
  return <PortalConfigContext.Provider value={getConfig()}>
    {children}
  </PortalConfigContext.Provider>;
};

PortalConfigProvider.propTypes = {
  children: PropTypes.node,
  config: PropTypes.object
};
